module.exports = __webpack_public_path__ + "img/UTGREA-8.6790e20f.jpg";